<script>
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppResumable from '@/components/AppResumable.vue'

export default {
  components: {
    AppResumable
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    id: {
      type: String,
      required: true
    },
    fileTypes: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    maxSixe: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      loading: false,
      success: false,
      percentage: 0,
      fileName: '',
      fileSize: ''
    }
  },

  computed: {
    validateRules () {
      return this.required ? 'required' : ''
    },
    targetUrl () {
      return this.$rotas.PUBLICO.UPLOAD
    }
  },

  methods: {
    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.fileType.join(', ')))
    },
    onSuccessEvent (value, fileKey) {
      this.success = true
      this.clear()
      this.$emit('uploadFile', {name: value.file.name, response: fileKey})
    },
    onFileAddedEvent (file) {
      this.$refs[this.id].uploadFile()
      this.loading = true
      this.fileName = file.file.name
      this.fileSize = this.formatFileSize(file.size)
    },
    onErrorEvent (message) {
      this.loading = false
    },
    onProgressEvent (progress) {
      this.percentage = progress
    },
    formatFileSize (input) {
      return parseFloat((input / 1000).toFixed(2)).toLocaleString('pt-BR').toString()
    },
    clear () {
      this.loading = false
      this.success = false
      this.percentage = 0
      this.fileName = ''
      this.fileSize = ''
    }
  }
}
</script>

<template>
  <div>
    <validation-provider :rules="validateRules" v-slot="{ errors }">
      <div class="w-100-per" :id="id">
        <transition name="idle-fade">
          <div v-if="!loading && !success" :class="['content', 'content-idle', {'error-upload' : errors.length}]">
            <span class="info">Arraste e solte ou clique para selecionar um arquivo.</span>
            <span class="format">Formato(s) suportado(s): {{ fileTypes.join(', ') }}</span>
          </div>
        </transition>
        <span v-if="!loading && errors.length">{{ errors[0] }}</span>
        <transition name="width">
          <el-row v-if="loading" class="content content-loader" :style="{width: (percentage < 20 ? 20 : percentage).toString() + '%'}">
            <el-col :span="12">
              <div class="name">{{ fileName }}</div>
              <div class="size">{{ fileSize }} Kb</div>
            </el-col>
            <transition name="buttons-and-label-fade">
              <el-col v-if="success" :span="12" class="column right float-left">
                <div class="label">Carregado com sucesso!</div>
              </el-col>
            </transition>
          </el-row>
        </transition>
      </div>
      <app-resumable
        :ref="id"
        :target="targetUrl"
        :fileType="fileTypes"
        :idDrop="id"
        :idInput="id"
        :fileTypeErrorCallback="fileTypeErrorCallback"
        @onSuccess="onSuccessEvent"
        @onError="onErrorEvent"
        @onProgress="onProgressEvent"
        @fileAdded="onFileAddedEvent"
        :maxSize="maxSixe"
      />
    </validation-provider>
  </div>
</template>

<style scoped lang="scss">
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/DocumentUpload/UploadResumable/UploadResumable.vue